import { Button } from 'web-library';
import React from 'react';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { useTheme } from '@mui/material/styles';

interface SaveButtonProps {
  label: string;
  saveHandler?: () => void;
  className?: string;
}

const SaveButton = (props: SaveButtonProps) => {
  const { label, saveHandler = () => null, className } = props;
  const theme = useTheme();

  return (
    <Button
      style={{ color: `${theme.color.link.linkDefault01}` }}
      color="primary"
      variant="text"
      onClick={saveHandler}
      type="submit"
      size="small"
      className={className}
      id="button-save-changes"
    >
      <IconWithLabel
        iconSize="M"
        iconName={IconName.save}
        iconColor={theme.color.link.linkDefault01}
        label={label}
        typographyProps={{
          variant: 'h5',
        }}
      />
    </Button>
  );
};

export default SaveButton;
